import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import { TransferDirectionRadioInput } from "../../enums/TransferDirectionEnum";
import Department from "../../types/Department";
import { handleRadioChange } from "../../utils/handleTransferDirection";

type Props = {
    department?: Department;
};

const TransferDirectionSection: React.FC<Props> = ({ department }) => {
    const { control, setValue } = useFormContext();
    const t = useTranslate();

    return (
        <div>
            <h4 className="text-base font-medium text-neutral-700 dark:text-neutral-300 mb-4">
                {t("transfers.message.typeOfTransfer")}
            </h4>
            <Controller
                name="direction"
                control={control}
                rules={{ required: t("common.feedback.field_required") }}
                render={({ field }) => (
                    <TransferDirectionRadioInput
                        value={field.value}
                        onChange={(event) => handleRadioChange(event, field.value, setValue)}
                        allowRoundTrip={department?.name?.toLowerCase() !== "package"}
                    />
                )}
            />
        </div>
    );
};

export default TransferDirectionSection;

